import { Vue, Component, Model, Watch, Prop } from "vue-property-decorator";

import { graphClient } from "@/services";
import { IUserGraph } from "@/models";

@Component
export default class PeoplePicker extends Vue {
    @Prop({ default: "Users", type: String })
    public readonly label?: string

    @Prop({ default: false, type: Boolean })
    public readonly closeOnClick?: boolean

    @Prop({ default: true, type: Boolean })
    public readonly dense?: boolean

    @Model("input", { required: true })
    public selectedUsers?: IUserGraph[];

    public internalSelectedUsers: IUserGraph[] = [];

    public items: IUserGraph[] = [];

    public usersPhotos: { id: string; photo: string }[] = [];

    public loading = false;

    public search = "";

    public timerId = 0;

    @Watch("search")
    public onSearchChanged(val: string): void {
        if (val && val.length >= 3) {
            this.querySelections(val);
        }
    }

    @Watch("selectedUsers")
    public onSelectedUsersChanged(val: IUserGraph[]): void {
        this.internalSelectedUsers = val;
        this.mergeUsers(val);
    }

    mounted(): void {
        this.internalSelectedUsers = this.selectedUsers ?? [];
        this.items = this.selectedUsers ?? [];
        this.loadPhotos(this.items);
    }

    public getDisplay(user: IUserGraph): string {
        return `${user.displayName} (${user.mail})`;
    }

    public getUserPhoto(user: IUserGraph): string {
        const userPhoto = this.usersPhotos.find(up => up.id === user.id);

        if (userPhoto) {
            return userPhoto.photo;
        }

        return "";
    }

    public querySelections(val: string): void {
        clearTimeout(this.timerId);
        this.timerId = setTimeout(() => {
            this.loading = true;
            graphClient.getFilteredUsers(val).then(users => {
                this.items = users;
                this.loadPhotos(users);
                this.loading = false;
            });
        }, 500);
    }

    public onSelectUser(): void {
        this.$emit("input", this.internalSelectedUsers);
    }

    private mergeUsers(users: IUserGraph[]): void {
        users.forEach(user => {
            const index = this.items.findIndex(item => item.id === user.id);
            if (index === -1) {
                this.items.push(user);
            }
        });
    }

    private loadPhotos(users: IUserGraph[]): void {
        users.forEach(user => {
            const userPhoto = this.usersPhotos.find(up => up.id === user.id);
            if (!userPhoto) {
                graphClient.getUserPhoto(user.id).then(photo => {
                    this.usersPhotos.push({ id: user.id, photo });
                });
            }
        });
    }
}
